import * as React from "react"
import { motion } from "framer-motion"

// const contactVariants = {
//   first: {
//     y: [200, 0,],
//     opacity: [0, 1,],
//     transition: {
//       duration: 1,
//       repeat: Infinity,
//       repeatType: 'reverse',
//       repeatDelay: 2.5

//     }
//   },
//   secound: {
//     y: [120, 0,],
//     opacity: [0, 1,],
//     transition: {

//       duration: 1,
//       repeat: Infinity,
//       repeatType: 'reverse',
//       repeatDelay: 2.5,
//       delay: 1,

//     }
//   },
//   third: {
//     y: [20, 0,],
//     opacity: [0, 1],
//     transition: {
//       duration: 1,
//       repeat: Infinity,
//       repeatType: 'reverse',
//       repeatDelay: 2.5,
//       delay: 1.5
//     }
//   }
// }
const contactVariants = {
  first: {
    y: [200, 0, 0, 0, 0, 0, 0],
    opacity: [0, 1, 1, 1, 1, 1, 1],
    transition: {
      duration: 5,
      repeat: Infinity,
      repeatType: "loop",
      // repeatDelay: 0.5
    },
  },
  secound: {
    y: [120, 120, 0, 0, 0, 0, 0],
    opacity: [0, 0, 1, 1, 1, 1, 1],
    transition: {
      duration: 5,
      repeat: Infinity,
      repeatType: "loop",
      // repeatDelay: 1,
    },
  },
  third: {
    y: [30, 30, 30, 0, 0, 0, 0],
    opacity: [0, 0, 0, 1, 1, 1, 1],
    transition: {
      duration: 5,
      repeat: Infinity,
      repeatType: "loop",
      // repeatDelay: 1,
    },
  },
}
const SvgContact = props => (
  <motion.svg
    xmlns="http://www.w3.org/2000/svg"
    width={359}
    height={244}
    {...props}
  >
    <path
      d="M321.958 238.211c-8.048 5.798-18.48 6.089-28.562 5.377-1.398-.1-2.795-.214-4.191-.342-.009-.002-.02-.001-.028-.004-.067-.006-.133-.012-.197-.016l-.855-.08.067.128.21.396-.226-.395c-.022-.04-.047-.08-.07-.119-2.612-4.546-5.202-9.258-5.863-14.447-.683-5.387 1.237-11.487 5.978-14.134a9.57 9.57 0 0 1 1.963-.822c.284-.086.572-.158.862-.219a10.258 10.258 0 0 1 11.926 13.331c4.02-4.122 3.27-10.808 1.883-16.396-1.389-5.589-3.071-11.807-.245-16.826 1.571-2.793 4.333-4.526 7.433-5.225a14.97 14.97 0 0 1 11.038 1.825c5.927 3.735 8.971 10.817 9.96 17.754 1.592 11.163-1.931 23.621-11.083 30.214Z"
      fill="#0CCE6B"
    />
    <path
      d="M319.36 220.316a25.431 25.431 0 0 1-1.757 7.169 22.067 22.067 0 0 1-3.429 5.602 28.31 28.31 0 0 1-10.873 7.84 40.708 40.708 0 0 1-9.905 2.661c-1.398-.1-2.795-.214-4.191-.342-.009-.002-.02-.001-.028-.004-.067-.006-.133-.012-.197-.016l-.855-.08.067.128.21.396-.226-.395c-.022-.04-.047-.08-.07-.119a22.515 22.515 0 0 0 6.311-19.698 22.69 22.69 0 0 0-4.233-9.705c.284-.087.571-.157.862-.219a23.639 23.639 0 0 1 2.148 3.558 23.063 23.063 0 0 1 1.99 14.353 23.592 23.592 0 0 1-5.976 11.766c.269-.02.538-.041.806-.066 5.033-.426 10.055-1.508 14.621-3.724a26.337 26.337 0 0 0 9.864-8.094c2.765-3.812 3.983-8.398 4.192-13.059a55.121 55.121 0 0 0-1.564-14.921 62.61 62.61 0 0 0-5.263-14.335.45.45 0 0 1 .179-.594.388.388 0 0 1 .285-.059.338.338 0 0 1 .22.189 63.36 63.36 0 0 1 5.801 16.563c1 4.962 1.534 10.152 1.011 15.205Z"
      fill="#FFF"
    />
    <path
      d="M14.973 77.555a1.95 1.95 0 0 1-.7-.132 1.908 1.908 0 0 1-1.223-1.788V55.607a2.56 2.56 0 0 0-2.556-2.557H6.392A6.398 6.398 0 0 1 0 46.659V6.392A6.399 6.399 0 0 1 6.392 0h144.675a6.399 6.399 0 0 1 6.392 6.392v40.267a6.4 6.4 0 0 1-6.392 6.392H39.399c-.717 0-1.4.301-1.885.828L16.382 76.931a1.907 1.907 0 0 1-1.408.624Z"
      fill="transparent"
    />
    {/* text box 1 */}
    <motion.path
      animate="first"
      variants={contactVariants}
      d="M6.392.852a5.545 5.545 0 0 0-5.54 5.54v40.267a5.547 5.547 0 0 0 5.54 5.54h4.101a3.412 3.412 0 0 1 3.409 3.408v20.028a1.065 1.065 0 0 0 1.851.72l21.132-23.051a3.42 3.42 0 0 1 2.513-1.105h111.669a5.546 5.546 0 0 0 5.54-5.54V6.392a5.545 5.545 0 0 0-5.54-5.54Z"
      fill="#D2D6DA "
      stroke="#A5ADB6"
    />
    {/* Avatar 1 */}
    <motion.path
      animate="first"
      variants={contactVariants}
      d="M10.085 12.543a5.593 5.593 0 1 1 11.188 0 5.593 5.593 0 0 1-11.188 0Z"
      fill="#A5ADB6"
    />
    {/* BOX 1 2 line */}
    <motion.path
      animate="first"
      variants={contactVariants}
      d="M144.542 43.49H12.917a2.984 2.984 0 0 1 0-5.966h131.625a2.983 2.983 0 1 1 0 5.966Z"
      fill="#A5ADB6"
    />
    {/* BOX 1 1 line */}
    <motion.path
      animate="first"
      variants={contactVariants}
      d="M101.661 30.813H12.917a2.984 2.984 0 0 1 0-5.966h88.744a2.983 2.983 0 1 1 0 5.966Z"
      fill="#A5ADB6"
    />
    <motion.path
      animate="third"
      variants={contactVariants}
      d="M6.837 143.703a5.546 5.546 0 0 0-5.54 5.54v40.268a5.545 5.545 0 0 0 5.54 5.539h4.101a3.413 3.413 0 0 1 3.409 3.409v20.028a1.067 1.067 0 0 0 1.851.72l21.132-23.051a3.418 3.418 0 0 1 2.513-1.106h111.669a5.545 5.545 0 0 0 5.54-5.54v-40.267a5.547 5.547 0 0 0-5.54-5.54Z"
      fill="#D2D6DA"
      stroke="#A5ADB6"
    />
    <motion.path
      animate="third"
      variants={contactVariants}
      d="M10.085 154.598a5.593 5.593 0 0 1 5.593-5.592 5.593 5.593 0 1 1-5.593 5.592ZM144.542 185.545H12.917a2.984 2.984 0 0 1 0-5.966h131.625a2.982 2.982 0 1 1 0 5.966Zm-42.881-12.677H12.917a2.984 2.984 0 0 1 0-5.966h88.744a2.982 2.982 0 1 1 0 5.966Z"
      fill="#A5ADB6"
    />
    <motion.path
      animate="secound"
      variants={contactVariants}
      d="M239.622 69.407a5.546 5.546 0 0 1 5.541 5.54v40.267a5.547 5.547 0 0 1-5.541 5.54h-4.101a3.412 3.412 0 0 0-3.409 3.408v20.028a1.065 1.065 0 0 1-1.851.72l-21.132-23.051a3.415 3.415 0 0 0-2.513-1.105H94.947a5.547 5.547 0 0 1-5.54-5.541V74.947a5.545 5.545 0 0 1 5.54-5.54Z"
      fill="#D2D6DA "
      stroke="#A5ADB6"
    />
    <motion.path
      animate="secound"
      variants={contactVariants}
      d="M96.219 80.402a5.593 5.593 0 1 1 11.188 0 5.593 5.593 0 0 1-11.188 0Z"
      fill="#3F3D56"
    />
    <motion.path
      animate="secound"
      variants={contactVariants}
      d="M230.676 111.348H99.051a2.984 2.984 0 0 1 0-5.966h131.625a2.983 2.983 0 1 1 0 5.966Zm-42.88-12.677H99.051a2.982 2.982 0 1 1 0-5.965h88.745a2.983 2.983 0 1 1 0 5.965Z"
      fill="hsl(149, 100%, 39%)"
    />
    <path
      d="M230.619 153.451a4.28 4.28 0 0 1 5.789-3.099l9.99-11.479 2.122 7.618-9.812 9.732a4.304 4.304 0 0 1-8.089-2.772ZM274.99 89.126c0-5.776 4.683-10.458 10.46-10.458 5.776 0 10.459 4.682 10.459 10.458 0 5.777-4.683 10.459-10.459 10.459-5.777 0-10.46-4.682-10.46-10.459ZM273.162 233.087h-5.221l-2.484-20.137 7.706.001Z"
      fill="#FFB8B8"
    />
    <path
      d="m274.494 238.148-16.835-.001v-.213c0-1.737.691-3.404 1.919-4.633a6.557 6.557 0 0 1 4.634-1.919l10.282.001Z"
      fill="#2F2E41"
    />
    <path d="M288.919 238.623h-5.221l-.723-19.656 5.945-.481Z" fill="#FFB8B8" />
    <path
      d="m290.25 243.684-16.834-.001v-.213a6.553 6.553 0 0 1 6.552-6.552h10.283Zm-2.816-8.736-4.065-.478a1.923 1.923 0 0 1-1.693-1.876l-.762-52.947a.64.64 0 0 0-1.241-.204l-5.641 15.926.404 29.851a1.916 1.916 0 0 1-1.801 1.939l-5.308.226a1.928 1.928 0 0 1-2.02-1.672l-2.772-33.768-.002-.021 4.206-35.267 31.592 2.285-8.77 74.328a1.919 1.919 0 0 1-2.127 1.678Z"
      fill="#2F2E41"
    />
    <path
      d="M266.874 159.783a1.904 1.904 0 0 1-1.003-1.541s2.841-17.665 3.882-17.997l-2.278-18.891a17.422 17.422 0 0 1 3.739-12.983 16.615 16.615 0 0 1 11.512-6.167c.319-.029.635-.051.95-.066a16.765 16.765 0 0 1 14.11 6.422 17.082 17.082 0 0 1 3.075 15.503l-1.277 4.446v31.066a1.94 1.94 0 0 1-.793 1.556c-3.978 2.919-8.474 3.951-12.842 3.951-8.267 0-16.079-3.696-19.075-5.299Z"
      fill="#0CCE6B"
    />
    <path
      d="m242.349 154.098-5.495-4.109a1.92 1.92 0 0 1-.254-2.841l32.733-35.12a6.411 6.411 0 0 1 8.313-.884 6.378 6.378 0 0 1 .82 9.784l-33.627 33.003a1.906 1.906 0 0 1-2.49.167Z"
      fill="#0CCE6B"
    />
    <path
      d="M284.402 149.448a4.282 4.282 0 0 1 6.267-1.962l11.96-9.408.66 7.88-11.459 7.726a4.305 4.305 0 0 1-7.428-4.236Z"
      fill="#FFB8B8"
    />
    <path
      d="M295.108 153.12a1.902 1.902 0 0 1-1.288-1.383l-1.208-5.074a1.89 1.89 0 0 1 .703-1.964l8.129-8.791-11.958-18.437a6.493 6.493 0 0 1 5.773-10.542 6.49 6.49 0 0 1 5.229 3.886l11.116 21.636a9.845 9.845 0 0 1-3.287 12.688l-11.361 7.588a1.899 1.899 0 0 1-1.848.393Z"
      fill="#0CCE6B"
    />
    <path
      d="M293.2 98.476a1.873 1.873 0 0 1-2.765-1.092l-.007-.026c-.212-.87-.044-1.781.011-2.675.055-.895-.038-1.876-.651-2.53-1.141-1.219-3.157-.559-4.799-.86a4.049 4.049 0 0 1-3.174-4.308 5.72 5.72 0 0 1 .098-.558 3.12 3.12 0 0 0-3.258-3.76c-1.659.104-3.446.616-4.825-.605a3.555 3.555 0 0 1-.874-3.829c.771-2.266 2.98-3.462 5.168-4.124a18.99 18.99 0 0 1 16.108 2.554c1.389.969 2.689 2.187 3.287 3.771.599 1.584.325 3.589-1 4.644a8.565 8.565 0 0 1 2.029 8.312c-.645 2.12-3.77 4.167-5.348 5.086Z"
      fill="#2F2E41"
    />
    <path
      d="M358.885 243.574a.428.428 0 0 1-.426.426H196.206a.425.425 0 0 1 0-.852h162.253a.428.428 0 0 1 .426.426Z"
      fill="#3F3D56"
    />
  </motion.svg>
)

export default SvgContact
